import { createSelector } from '@reduxjs/toolkit';

import { getLayoutModelsWithPendingChanges } from '@paragon/layout-models';

import { RootState } from '../slices';

export const getAnalysisSetGuidToComponentDesignName = createSelector(
  (state: RootState) => state.analysisHistory,
  getLayoutModelsWithPendingChanges,

  (analysisHistory, layoutModels) =>
    Object.fromEntries(
      Object.values(analysisHistory)
        .flatMap((historyForComponentDesign) =>
          historyForComponentDesign ? Object.values(historyForComponentDesign) : [],
        )
        .map((historyRecord) => {
          const componentDesignName = layoutModels[historyRecord.componentDesignGuid]?.name ?? 'unknown';
          return [historyRecord.analysisSetGuid, componentDesignName] as const;
        }),
    ),
);
